import React from "react";
import {
  DescriptionList,
  DescriptionTerm,
  DescriptionDetails,
} from "../../../design/description-list";
import MatterTypeBadge from "../../../components/MatterTypeBadge";
import { Matter } from "../../../models/Matter";
import MatterStatusBadge from "../../../components/MatterStatusBadge";
import moment from "moment";
import { Heading } from "../../../design/heading";
import { useMatterType } from "../../../contexts/MatterTypeContext";
import EditMatterButton from "../../MatterDetailPage/components/EditMatterButton";
import { useParticipant } from "../../../contexts/ParticipantContext";
import { Link } from "../../../design/link";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";

interface MatterOverviewProps {
  currentMatter: Matter;
}

export const MatterOverview: React.FC<MatterOverviewProps> = ({
  currentMatter,
}) => {
  const { matterTypes } = useMatterType();
  const matterType = matterTypes.find(
    (type) => type._id === currentMatter?.matterType,
  );

  return (
    <div className="p-4 pt-4 my-4 bg-white border rounded-md shadow-lg dark:bg-black">
      <div className="flex items-center justify-between mb-4">
        <Heading>Matter Overview</Heading>
        <EditMatterButton matter={currentMatter}>
          <EllipsisHorizontalIcon className="w-5 h-5" />
        </EditMatterButton>
      </div>
      <DescriptionList>
        {matterType && (
          <>
            <DescriptionTerm>Type</DescriptionTerm>
            <DescriptionDetails>
              <MatterTypeBadge matterType={matterType} />
            </DescriptionDetails>
          </>
        )}
        {currentMatter.identifier ? (
          <>
            <DescriptionTerm>Identifier</DescriptionTerm>
            <DescriptionDetails>{currentMatter?.identifier}</DescriptionDetails>
          </>
        ) : null}
        <DescriptionTerm>Status</DescriptionTerm>
        <DescriptionDetails>
          <MatterStatusBadge status={currentMatter?.status ?? "pending"} />
        </DescriptionDetails>
        {currentMatter.dateOfMarriage ? (
          <>
            <DescriptionTerm>Marriage Date</DescriptionTerm>
            <DescriptionDetails>
              {moment(currentMatter?.dateOfMarriage).format("ll")}
            </DescriptionDetails>
          </>
        ) : null}
        {currentMatter.dateOfSeparation ? (
          <>
            <DescriptionTerm>Separation Date</DescriptionTerm>
            <DescriptionDetails>
              {moment(currentMatter?.dateOfSeparation).format("ll")}
            </DescriptionDetails>
          </>
        ) : null}
        {currentMatter.dateOfDivorce ? (
          <>
            <DescriptionTerm>Divorce Date</DescriptionTerm>
            <DescriptionDetails>
              {moment(currentMatter?.dateOfDivorce).format("ll")}
            </DescriptionDetails>
          </>
        ) : null}
        {currentMatter.residenceState ? (
          <>
            <DescriptionTerm>State of Residence</DescriptionTerm>
            <DescriptionDetails>
              {currentMatter?.residenceState}
            </DescriptionDetails>
          </>
        ) : null}
        {currentMatter.residenceCounty ? (
          <>
            <DescriptionTerm>County of Residence</DescriptionTerm>
            <DescriptionDetails>
              {currentMatter?.residenceCounty}
            </DescriptionDetails>
          </>
        ) : null}
      </DescriptionList>
    </div>
  );
};
